import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = (window.ENV?.REACT_APP_BACKEND_URL || window.location.origin) + '/api';

const MainHeader = ({ 
  projectId, 
  activeTab = 'walkthrough',
  hideNavigation = false,
  sheetLabel = ''
}) => {
  const [project, setProject] = useState(null);
  
  useEffect(() => {
    if (projectId) {
      axios.get(`${API_URL}/projects/${projectId}`)
        .then(response => setProject(response.data))
        .catch(err => console.error('Error loading project:', err));
    }
  }, [projectId]);
  
  // Use project name or client last name - NEVER default to "GREENE"
  const displayName = project?.name?.toUpperCase() || project?.client_info?.full_name?.split(' ').pop()?.toUpperCase() || 'PROJECT';
  const clientFullInfo = project?.client_info 
    ? [project.client_info.full_name, project.client_info.address].filter(Boolean).join(' · ')
    : project?.name || '';
  const CG = "'Century Gothic','CenturyGothic','Questrial','URW Gothic',AppleGothic,sans-serif";

  // OPTION B — one consolidated header: logo band (kept), then the sheet label,
  // the project NAME and the client/address ONCE, all in Century Gothic. This
  // replaces the old header that repeated the name three times.
  return (
    <div className="w-full">
      {/* LOGO BANNER (kept) */}
      <div className="w-full flex items-center justify-center" style={{ background: '#000', padding: '10px 0' }}>
        <img 
          src="https://customer-assets.emergentagent.com/job_sleek-showcase-46/artifacts/c5c84fh5_Established%20logo.png"
          alt="Established Design Co. Logo" 
          style={{ height: '120px', width: 'auto', objectFit: 'contain', display: 'block', filter: 'brightness(0) invert(1)' }}
        />
      </div>

      {/* Consolidated identity — sheet label · name · address (once, Century Gothic) */}
      <div className="text-center" style={{ padding: '18px 16px 14px' }}>
        {sheetLabel ? (
          <div style={{ fontFamily: CG, color: '#C9A05E', fontSize: '12px', letterSpacing: '5px', marginBottom: '8px', textTransform: 'uppercase' }}>
            {sheetLabel}
          </div>
        ) : null}
        <div data-testid="sheet-project-name" style={{ fontFamily: CG, color: '#EADFCB', fontSize: '34px', letterSpacing: '7px', lineHeight: 1.1 }}>
          {displayName}
        </div>
        <div style={{ width: '120px', height: '2px', margin: '12px auto', background: 'linear-gradient(90deg, transparent, #C9A05E, transparent)' }} />
        {clientFullInfo ? (
          <div style={{ fontFamily: CG, color: '#B49B7E', fontSize: '13px', letterSpacing: '2px' }}>
            {clientFullInfo}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MainHeader;